import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title} 
          description={post.frontmatter.title || post.excerpt}
        />
        <section className="illus freebies">
            <div className="container">
            <div className="title">
              <h1>{post.frontmatter.title}</h1>
            </div>
            
              <div className="illus-wrap">
                <div className="day-box">
                  <div className="i-wrap">

                    <div className="img">
                    <img src={post.frontmatter.png.childImageSharp.fluid.src}/>
                    </div>
                  
                  </div>
                </div>
              </div>

              <div className="feature-dwn">
                <div className="btn-lnks">
                  <a href={post.frontmatter.png.publicURL} download className="btn btn-coffee"><h4>Download PNG</h4></a>
                </div>
            </div>
          </div>
        </section>      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date
        category
       
        png {
          publicURL
        }
        tags
        png{
          childImageSharp {
            fluid {
              src
            }
          }
        }
      }
    }
  }
`